module.exports = __webpack_public_path__ + "img/icon-cart.66d570bf.svg";